import socket from "../socket";
import axios from "axios";
import {BASE_URL, CONFIG} from "../constants";


export class UserRequest {
    static registration(payload: []): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(BASE_URL + '/users/registration', payload, CONFIG);
                if (response.status === 200) {
                    resolve(response.data)
                }
            } catch (error) {
                console.error('Error:', error);
                throw error; // Пробрасываем ошибку дальше
            }
        })
    }

    static login(payload: []): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(BASE_URL + '/users/login', payload, CONFIG);
                if (response.status === 200) {
                    resolve(response.data)
                }
            } catch (error) {
                console.error('Error:', error);
                throw error; // Пробрасываем ошибку дальше
            }
        })
    }

    static resetPassword(email: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            socket.emit('reset-password', email, (response: any) => {
                try {
                    socket.off('reset-password');
                    resolve(response)
                } catch (e) {
                    reject(e)
                }
            })
        })
    }

    static userInfo(payload: {}): Promise<any> {
        return new Promise(async (resolve, reject) => {
            socket.emit('user-info', payload, (response: any) => {
                try {
                    socket.off('user-info');
                    resolve(response)
                } catch (e) {
                    reject(e)
                }
            })
        })
    }

    static entitiesInfo(payload: {}): Promise<any> {
        return new Promise(async (resolve, reject) => {
            socket.emit('info-entities', payload, (response: any) => {
                try {
                    socket.off('info-entities');
                    resolve(response)
                } catch (e) {
                    reject(e)
                }
            })
        })
    }

    static resetNewPassword(payload: { pass: string, token: string }): Promise<any> {
        return new Promise(async (resolve, reject) => {
            socket.emit('reset-new-password', payload, (response: any) => {
                try {
                    socket.off('reset-new-password');
                    resolve(response)
                } catch (e) {
                    reject(e)
                }
            })
        })
    }
}
